




















































































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
// 混入
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
// 接口
import {
  returnList,
  orderUpdateRemark,
  orderUpdateStatus,
  orderSendExpress,
  selectExpress,
  orderRefund,
  rejectRefund,
  agreeReturn,
  rejectReturn,
  confirmTakeReturnGoods,
} from "@/api/order";
import { expressCompanyList } from "@/api/freight";
import copy from "@/utils/deepCopy";
import inputPrice from "@/utils/inputPrice";
// ts
import { InitOptions, initOptions } from "../type/index";

@Component
export default class Table extends Mixins(loading, tablePagination) {
  // 父组件传值
  @Prop() private fromDate!: string;
  @Prop() private productName!: string;
  @Prop() private shopName!: string;
  @Prop() private phone!: string;
  @Prop() private memberName!: string;
  @Prop() private expressNo!: number;
  @Prop() private orderStatus!: number;
  // 构造器自有属性
  tableData: Array<any> = []; // 订单列表
  orderDetail: Array<any> = []; // 订单详情
  dialogVisible: boolean = false; // 对话框显示订单详情
  dialogVisibleRemark: boolean = false; // 订单备注对话框
  form: any = {
    remark: "",
    id: 0,
    status: "",
    expressName: "",
    expressNo: "",
    shipperCode: "",
  };
  type: string = "remark";
  options: Array<{ value: number; label: string }> = copy(initOptions);
  // 物流信息
  initActivities: Array<{
    content: string;
    timestamp: string;
    color?: string;
  }> = [
    {
      content: "已签收",
      timestamp: "2018-04-15",
      color: "#f56c6c",
    },
    {
      content: "快递员开始派送",
      timestamp: "2018-04-15",
    },
    {
      content: "扫描完成",
      timestamp: "2018-04-15",
    },
    {
      content: "拣货完成",
      timestamp: "2018-04-13",
    },
    {
      content: "温馨提示：您的订单将在9月10号送到您手中",
      timestamp: "2018-04-11",
    },
  ];
  activities: Array<{
    content: string;
    timestamp: string;
    color?: string;
  }> = [];
  disabled: boolean = false;
  dialogVisibleImg: boolean = false;
  dialogImageUrl: string = "";
  expressCompanyList_: any = [];
  /**
   * 生命周期
   */
  mounted() {
    this.getData();
    this.getExpressCompany();
  }
  /**
   * methods
   */
  getData() {
    this.showLoading();
    returnList({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      productName: this.productName,
      shopName: this.shopName,
      phone: this.phone,
      expressNo: this.expressNo,
      orderStatus: this.orderStatus,
      nickname: this.memberName,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    }).then((res: any) => {
      res.data.list.forEach((e: any) => {
        e.visible = false;
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
      this.$emit("total", this.total);
    });
  }
  // 修改订单状态
  updateStatus(row: any, type: string) {
    if (row.shippingMethod == 1 && row.status == 3) {
      this.type = "express";
      this.dialogVisibleRemark = true;
    } else if (row.shippingMethod == 2 && row.status == 3) {
      this.$confirm("客户是否上门自提货物?", "自提发货", {
        confirmButtonText: "是的",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderUpdateStatus({
          id: row.id,
          status: 5, // 已发货
        }).then((res: any) => {
          this.$message({
            type: "success",
            message: "设置成功!",
          });
        });
      });
    } else {
      this.options = initOptions.filter((e: any) => e.value > row.status);
      this.type = "status";
      this.dialogVisibleRemark = true;
    }
    this.form.id = row.id;

    // if (row.status == 1) {
    //   this.type = "express";
    // } else {
    //   this.type = "status";
    // }
    // this.form.id = row.id;
    // this.dialogVisibleRemark = true;
  }
  // 修改备注
  updateRemark(row: any) {
    this.type = "remark";
    this.form.remark = row.note;
    this.form.id = row.id;
    this.dialogVisibleRemark = true;
  }
  // 确认修改修改订单
  async confirmUpdate(row: any) {
    let pro: any = null;
    let form = this.form;
    switch (this.type) {
      case "remark":
        pro = await orderUpdateRemark(form);
        break;
      case "status":
        if (
          form.status == 7 ||
          form.status == 9 ||
          form.status == 11 ||
          form.status == 13
        ) {
          pro = await orderUpdateStatus(form);
        } else {
          this.$message.error("选择状态有误");
          return;
        }
        break;
      case "express":
        let name = this.expressCompanyList_.find(
          (e: { id: number }) => e.id == form.expressId
        );
        pro = await orderSendExpress({
          orderId: form.id,
          expressName: name && name.expressName,
          expressNo: form.expressNo,
          expressId: form.expressId,
        });
      // pro = await orderSendExpress({
      //   orderId: form.id,
      //   expressName: form.expressName,
      //   expressNo: form.expressNo,
      //   expressId: "",
      // });
      default:
        break;
    }
    this.$message.success("修改成功");
    this.dialogVisibleRemark = false;
    this.getData();
  }
  // 显示物流
  showFreight(row: any, index: number) {
    if (row.status == 2 || row.status == 3) {
      this.tableData[index].visible = true;
      this.activities = copy(this.initActivities);
      // selectExpress({ id: row.id }).then((res: any) => {});
    }
  }
  hideFreight(index: number) {
    this.tableData[index].visible = false;
  }
  // 预览图片
  previewImg(url: string) {
    this.dialogImageUrl = url;
    this.dialogVisibleImg = true;
  }
  // 发起退款
  orderRefundfun(item: any) {
    this.$confirm("是否确认退款?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      orderRefund({
        orderId: item.orderId,
        subOrderIds: item.id,
      }).then((res: any) => {
        this.$message.success("退款成功");
        this.getData();
      });
    });
  }
  // 取消退款
  rejectRefundfun(item: any) {
    this.$confirm("是否拒绝退款?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      rejectRefund({
        orderId: item.orderId,
        subOrderIds: item.id,
      }).then((res: any) => {
        this.$message.success("拒绝成功");
        this.getData();
      });
    });
  }
  // 同意申请
  agreeReturn_(item: any) {
    this.$confirm("是否同意申请?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      agreeReturn({
        orderId: item.orderId,
        subOrderIds: item.id,
      }).then((res: any) => {
        this.$message.success("已同意申请");
        this.getData();
      });
    });
  }
  // 拒绝申请
  rejectReturn_(item: any) {
    this.$confirm("是否拒绝申请?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      rejectReturn({
        orderId: item.orderId,
        subOrderIds: item.id,
      }).then((res: any) => {
        this.$message.success("已拒绝申请");
        this.getData();
      });
    });
  }
  // 确认收货
  confirmTakeReturnGoods_(item: any) {
    this.$confirm("是否确认收货?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      confirmTakeReturnGoods({
        orderId: item.orderId,
        subOrderIds: item.id,
      }).then((res: any) => {
        this.$message.success("收货成功");
        this.getData();
      });
    });
  }
  // 获取快递公司
  getExpressCompany() {
    expressCompanyList().then((res) => {
      this.expressCompanyList_ = res.data;
    });
  }
  // 过滤三位小数
  filterPrice(val: number) {
    return inputPrice(val, "4");
  }
}
